import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedComponent } from '@shared/shared.component';
import { ScriptService } from '@shared/script.service';
import { SharedService } from '@shared/shared.service';
import { KeyValuePipe } from '@shared/key-value.pipe';
import { FilterPipe } from '@shared/filter.pipe';
import { ColumnFilterPipe } from '@shared/column-filter.pipe';
import { NotifyMessageComponent } from '@shared/notify-message/notify-message.component';
import { TranslatePipe, TranslateDirective } from '@ngx-translate/core';
import { SideMenuComponent } from '@shared/side-menu/side-menu.component';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
// import { OwlDateTimeModule, OwlNativeDateTimeModule } from 'ng-pick-datetime';
import { PermissionGuard } from '@myproject/perimission.guard';
import { AuthGuard } from '@myproject/auth.guard';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapServiceComponent } from '@shared/map-service/map-service.component';
import { BarGraphComponent } from './bar-graph/bar-graph.component';
import { LineGraphComponent } from './line-graph/line-graph.component';
import { ScatterChartComponent } from './scatter-chart/scatter-chart.component';
import { CalendarComponent } from './calendar/calendar.component';
import { InlineEditComponent } from './inline-edit/inline-edit.component';
import { MyRenderer } from '@shared/inline-edit/inline-edit.service';
import { InlineEditSelectComponent } from './inline-edit-select/inline-edit-select.component';
import { StackedBarGraphComponent } from './stacked-bar-graph/stacked-bar-graph.component';
import { DateTimeCalendarComponent } from './date-time-calendar/date-time-calendar.component';
import { NgbDatepickerModule, NgbTimepickerModule, NgbTooltipModule, } from '@ng-bootstrap/ng-bootstrap';
import { SearchSelectVehicleComponent } from './search-select-vehicle/search-select-vehicle.component';
import { SearchSelectDeviceComponent } from './search-select-device/search-select-device.component';
import { ConfirmDeleteModalComponent } from './confirm-delete-modal/confirm-delete-modal.component';
import { FileSizePipe } from './custom-pipes/file-size.pipe';
// import { TooltipModule } from 'ng2-tooltip-directive';
import { SecondsToHmsPipe } from '@myproject/shared/seconds-to-hms.pipe';
import { EllipsesPipe } from '@myproject/shared/ellipses/ellipses.pipe';
import { CalendarGraphComponent } from './calendar-graph/calendar-graph.component';
import { OtaFileUploadModalComponent } from './ota-file-upload-modal/ota-file-upload-modal.component';
import { DeviceActivityComponent } from './campaign-device-activity/device-activity.component';
import { DistanceMetricsPipe } from '@myproject/shared/distance-metrics.pipe';
import { DataTabHeaderComponent } from './data-tab-header/data-tab-header.component';
import { ObdpidComponent } from './obdpid/obdpid.component';
import { TimeSeekerComponent } from './time-seeker/time-seeker.component';
import { DashboardHeaderComponent } from '@components/dashboard/dashboard-header/dashboard-header.component';
import { ObdPidViewComponent } from './obd-pid-view/obd-pid-view.component';
// import { ObdPidViewDirective } from './obd-pid-view/obd-pid-view.directive';
import { BillingReportComponent } from '../components/graphic-reports/system-reports/billing-report/billing-report.component';
import { ReportsHeaderComponent } from '../components/graphic-reports/reports-header/reports-header.component';
import { ReportsSideMenuComponent } from '../components/graphic-reports/reports-side-menu/reports-side-menu.component';
import { ReplayCustomCalendarComponent } from './replay-custom-calendar/replay-custom-calendar.component';
import { ButtonComponent } from "./button/button.component";
import { TextboxComponent } from "./textbox/textbox.component";
import { ReactiveFormsModule } from "@angular/forms";
import { RadioButtonGroupComponent } from "./radio-button-group/radio-button-group.component";
import { ToggleSwitchComponent } from "./toggle-switch/toggle-switch.component";
import { CheckboxGroupComponent } from "./checkbox-group/checkbox-group.component";
import { DropdownComponent } from "./dropdown/dropdown.component";
import { ButtonDropdownComponent } from "./button-dropdown/button-dropdown.component";
import { NavigationTabsComponent } from "./navigation-tabs/navigation-tabs.component";
import { DataTableComponent } from "./data-table/data-table.component";
import { DatePickerComponent } from "./date-picker/date-picker.component";
import { SettingRowComponent } from "./setting-row/setting-row.component";
import { BreadcrumbStepperComponent } from "./breadcrumb-stepper/breadcrumb-stepper.component";
import { DeployTilesComponent } from "./deploy-tiles/deploy-tiles.component";
import { PopupModalComponent } from "./popup-modal/popup-modal.component";
import { ConfirmationPopupComponent } from "./confirmation-popup/confirmation-popup.component";
import { SectionsComponent } from "./sections/sections.component";
import { SubsectionComponent } from "./subsection/subsection.component";
import { HeaderComponent } from "@myproject/components/header/header.component";
import { FooterComponent } from "@myproject/layouts/footer/footer.component";

@NgModule({
  imports: [
    CommonModule,
    TranslatePipe,
    TranslateDirective,
    RouterModule,
    NgxDatatableModule,
    NgSelectModule,
    FormsModule,
    // OwlDateTimeModule,
    // OwlNativeDateTimeModule,
    NgbDatepickerModule,
    NgbTimepickerModule,
    // TooltipModule,
    NgbTooltipModule,
    ReactiveFormsModule,
    ButtonDropdownComponent,
  ],
  exports : [
    HeaderComponent,
    FooterComponent,
    SharedComponent,
    NotifyMessageComponent,
    KeyValuePipe,
    FilterPipe,
    ColumnFilterPipe,
    TranslatePipe,
    TranslateDirective,
    SideMenuComponent,
    MapServiceComponent,
    BarGraphComponent,
    LineGraphComponent,
    ScatterChartComponent,
    CalendarComponent,
    InlineEditComponent,
    InlineEditSelectComponent,
    StackedBarGraphComponent,
    DateTimeCalendarComponent,
    SearchSelectVehicleComponent,
    SearchSelectDeviceComponent,
    ConfirmDeleteModalComponent,
    FileSizePipe,
    SecondsToHmsPipe,
    EllipsesPipe,
    CalendarGraphComponent,
    OtaFileUploadModalComponent,
    DeviceActivityComponent,
    DistanceMetricsPipe,
    DataTabHeaderComponent,
    ObdpidComponent,
    TimeSeekerComponent,
    DashboardHeaderComponent,
    ObdPidViewComponent,
    BillingReportComponent,
    ReportsHeaderComponent,
    ReportsSideMenuComponent,
    ReplayCustomCalendarComponent,
    ButtonComponent,
    TextboxComponent,
    RadioButtonGroupComponent,
    ToggleSwitchComponent,
    CheckboxGroupComponent,
    DropdownComponent,
    ButtonDropdownComponent,
    NavigationTabsComponent,
    DataTableComponent,
    DatePickerComponent,
    SettingRowComponent,
    BreadcrumbStepperComponent,
    DeployTilesComponent,
    PopupModalComponent,
    ConfirmationPopupComponent,
    SectionsComponent,
    SubsectionComponent,
  ],
  declarations: [
    HeaderComponent,
    FooterComponent,
    SharedComponent,
    NotifyMessageComponent,
    KeyValuePipe,
    FilterPipe,
    ColumnFilterPipe,
    SideMenuComponent,
    MapServiceComponent,
    BarGraphComponent,
    LineGraphComponent,
    ScatterChartComponent,
    CalendarComponent,
    InlineEditComponent,
    InlineEditSelectComponent,
    StackedBarGraphComponent,
    DateTimeCalendarComponent,
    SearchSelectVehicleComponent,
    SearchSelectDeviceComponent,
    ConfirmDeleteModalComponent,
    FileSizePipe,
    SecondsToHmsPipe,
    EllipsesPipe,
    CalendarGraphComponent,
    OtaFileUploadModalComponent,
    DeviceActivityComponent,
    DistanceMetricsPipe,
    DataTabHeaderComponent,
    ObdpidComponent,
    TimeSeekerComponent,
    DashboardHeaderComponent,
    ObdPidViewComponent,
    BillingReportComponent,
    ReportsHeaderComponent,
    ReportsSideMenuComponent,
    ReplayCustomCalendarComponent,
    ButtonComponent,
    TextboxComponent,
    RadioButtonGroupComponent,
    ToggleSwitchComponent,
    CheckboxGroupComponent,
    DropdownComponent,
    NavigationTabsComponent,
    DataTableComponent,
    DatePickerComponent,
    SettingRowComponent,
    BreadcrumbStepperComponent,
    DeployTilesComponent,
    PopupModalComponent,
    ConfirmationPopupComponent,
    SectionsComponent,
    SubsectionComponent,
  ],
  providers : [ScriptService, SharedService, PermissionGuard, AuthGuard, MyRenderer]
})
export class SharedModule { }
